var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TabButton",on:{"click":_vm.handleSelection}},[_c('span',{staticClass:"text__psb"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/common/arrow-right.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }